export * from './src/page-no-access-unauthorized.module';
